import styled from 'styled-components';

export const PublishStatusStyle = styled.span`
  font-weight: bold;
  font-size: 8px;
  visibility: hidden; 
  opacity: 0; 
  position: absolute;
  left: 15px;
  white-space: nowrap;
  transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out;
  color: ${(props) => props.theme['themeId'] === 'dark'
    ? props.theme['color.white']
    : props.theme['color.text.body']};
`;

export const PublishStatusCircle = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${(props) => props.color};
  margin-top: 2px;
  position: relative;

  &:hover ${PublishStatusStyle} {
    visibility: visible;
    opacity: 1;
  }
`;

export const HollowCircle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 8px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  position: relative;
  background: ${(props) => props.theme['color.redLight']};
  color: white;
  overflow: 'hidden';

  &::before {
    content: "!";
    display: inline-block;
    font-size: 12px;
    font-weight: bolder;
  }

  &:hover ${PublishStatusStyle} {
    visibility: visible;
    opacity: 1;
  }
`;
